export var TYPE_ITEMS = {

    OPEN: "open",

    OPEN_INSOR: "open_insor",

    OPEN_FILE: "open_file",

}